// Libraries
import React, { Component } from 'react'
import { Icon } from 'antd'
import './Loader.less'

class Loader extends Component {
  render() {
    return (
      <div className='permit-details-loader'>
        <Icon type='loading' />
      </div>
    )
  }
}

export default Loader
